/** FAQ, Support, and Advertising page copy (Ukrainian translation). */
export const pagesMessagesUk = {
  faq: {
    pageTitle: "Часті запитання",
    pageSubtitle: "Знайдіть відповіді на поширені запитання про WasOK",
    seoTitle: "Часті запитання — WasOK",
    seoDescription:
      "Відповіді на поширені запитання про WasOK, сканування товарів, конфіденційність та оцінки.",
    items: [
      {
        question: "Як працює WasOK?",
        answer:
          "WasOK допомагає вам пам’ятати, які товари вам сподобалися чи не сподобалися, скануючи штрихкоди та зберігаючи ваші оцінки й нотатки. Просто відскануйте штрихкод товару, оцініть його, додайте нотатки, і наступного разу, відсканувавши той самий товар, ви одразу побачите свій попередній відгук.",
      },
      {
        question: "Чи зберігаються мої дані в хмарі?",
        answer:
          "Ні! Усі ваші дані зберігаються локально на вашому пристрої. Ми не синхронізуємо вашу інформацію з хмарою, а це означає, що історія покупок і думки про товари залишаються повністю приватними. Однак це також означає, що вам варто робити резервну копію пристрою, якщо ви хочете зберегти свої дані.",
      },
      {
        question: "Чи потрібне інтернет-з’єднання для використання WasOK?",
        answer:
          "Ні, WasOK повністю працює офлайн. Оскільки всі ваші дані зберігаються локально на пристрої, ви можете сканувати товари, додавати оцінки та переглядати історію без будь-якого інтернет-з’єднання.",
      },
      {
        question: "Чи можу я використовувати WasOK для будь-якого типу товарів?",
        answer:
          "Так! WasOK працює з будь-яким товаром, що має штрихкод. Чи це їжа, косметика, товари для дому, електроніка чи щось інше зі штрихкодом — ви можете відсканувати це та зберегти свою думку.",
      },
      {
        question: "Як відсканувати штрихкод?",
        answer:
          "Просто відкрийте застосунок WasOK і натисніть кнопку сканування. Наведіть камеру на штрихкод товару, і застосунок автоматично розпізнає й відсканує його. Для найкращого результату переконайтеся, що штрихкод добре освітлений і в фокусі.",
      },
      {
        question: "Чи можу я додавати фото до відгуків про товари?",
        answer:
          "Так! Ви можете додавати фото до будь-якого відгуку про товар. Це особливо корисно, щоб пам’ятати деталі упаковки, список інгредієнтів або іншу візуальну інформацію, яка допоможе згадати, чому товар сподобався чи не сподобався.",
      },
      {
        question: "Яку інформацію я можу зберігати про товари?",
        answer:
          "Ви можете зберігати оцінки (від 1 до 5 зірок), текстові нотатки, фото, ціну, яку заплатили, місце покупки та власні категорії. Ця детальна інформація допомагає приймати зважені рішення під час покупок.",
      },
      {
        question: "Чи можу я створювати списки покупок?",
        answer:
          "Так! WasOK дозволяє створювати списки покупок із товарів, які ви вже оцінили. Це полегшує запам’ятовування того, які товари вам сподобалися і які ви хочете купити знову.",
      },
      {
        question: "Як організувати мої товари?",
        answer:
          "Ви можете організовувати товари за допомогою власних категорій. Наприклад, можна створити категорії «Снеки», «Кава», «Догляд за шкірою» або «Засоби для прибирання». Це полегшує перегляд відгуків за типом.",
      },
      {
        question: "Чи WasOK безкоштовний?",
        answer:
          "Так, WasOK повністю безкоштовний для завантаження та використання. Немає жодних покупок у застосунку, підписок чи прихованих платежів. Ми віримо, що кожен повинен мати доступ до приватного способу пам’ятати свої вподобання щодо товарів.",
      },
      {
        question: "Чи доступний WasOK для людей з обмеженими можливостями?",
        answer:
          "WasOK розроблено так, щоб ним могло користуватися якомога більше людей. Застосунок містить функції доступності, такі як підтримка програм читання з екрана, масштабований текст і опційний режим високої контрастності.",
      },
      {
        question: "Що станеться, якщо я видалю застосунок?",
        answer:
          "Оскільки всі дані зберігаються локально на пристрої, видалення застосунку видалить усі ваші відгуки про товари, нотатки та списки покупок. Обов’язково експортуйте свої дані, якщо хочете зберегти резервну копію перед видаленням.",
      },
      {
        question: "Чи можу я експортувати свої дані?",
        answer:
          "Так, WasOK дозволяє експортувати дані для резервного копіювання. Ви можете експортувати всі свої відгуки у файл, який можна зберегти на пристрої або в хмарному сховищі на ваш вибір.",
      },
      {
        question: "Чи відстежує WasOK моє місцезнаходження?",
        answer:
          "Ні, WasOK не відстежує ваше місцезнаходження. Хоча ви можете вручну вказати назву магазину, де купили товар, застосунок не використовує GPS або служби геолокації.",
      },
      {
        question: "Чи можу я використовувати WasOK на кількох пристроях?",
        answer:
          "Наразі WasOK не синхронізується між пристроями, оскільки всі дані зберігаються локально. Кожен пристрій матиме власну окрему базу товарів і відгуків.",
      },
      {
        question: "Що робити, якщо штрихкод не сканується?",
        answer:
          "Якщо штрихкод не сканується, переконайтеся, що він добре освітлений і в фокусі. Також можна спробувати протерти об’єктив камери. Якщо штрихкод пошкоджений або нечіткий, ви можете ввести номер штрихкоду вручну.",
      },
    ],
    cta: {
      heading: "Залишилися запитання?",
      body: "Зв’яжіться з нашою службою підтримки — ми завжди раді допомогти.",
      button: "Зв’язатися з підтримкою",
    },
  },
  support: {
    pageTitle: "Підтримка",
    seoTitle: "Підтримка — WasOK",
    seoDescription:
      "Отримайте допомогу з WasOK: зв’яжіться з підтримкою, повідомте про помилку, поділіться відгуком.",
    getHelp: {
      title: "Отримати допомогу",
      body: "Ми тут, щоб допомогти вам отримати максимум від WasOK. Якщо у вас виникли проблеми чи запитання, у нас є кілька ресурсів, які вам допоможуть.",
    },
    faq: {
      title: "Часті запитання",
      body: "Перш ніж звертатися до нас, перегляньте розділ частих запитань, де ми відповідаємо на найпоширеніші запитання про WasOK. Там ви знайдете детальну інформацію про роботу застосунку, конфіденційність, зберігання даних тощо.",
    },
    contact: {
      title: "Зв’язатися з підтримкою",
      body: "Якщо ви не знайшли відповідь, яку шукали, наша служба підтримки готова допомогти. Ви можете зв’язатися з нами за адресою:",
      emailLabel: "Email:",
      responseTime: "Зазвичай ми відповідаємо протягом 24-48 годин",
    },
    bugs: {
      title: "Повідомлення про помилки",
      body: "Знайшли помилку? Ми цінуємо вашу допомогу в покращенні WasOK. Повідомляючи про помилку, будь ласка, вкажіть:",
      items: [
        "Детальний опис проблеми",
        "Кроки для відтворення проблеми",
        "Модель вашого пристрою та версію Android",
        "Скріншоти або записи екрана, якщо можливо",
      ],
      sendPrefix: "Надсилайте звіти про помилки на:",
    },
    featureRequests: {
      title: "Пропозиції щодо функцій",
      bodyBefore: "Маєте ідею нової функції? Ми будемо раді почути вас! Надсилайте свої пропозиції на",
      bodyAfter:
        ". Хоча ми не можемо реалізувати кожен запит, ми уважно враховуємо всі відгуки під час планування майбутніх оновлень.",
    },
    knownIssues: {
      title: "Відомі проблеми",
      body: "Наразі нам відомо про такі проблеми, і ми працюємо над їх вирішенням:",
      items: [
        "Деякі штрихкоди можуть не сканувати при слабкому освітленні — спробуйте використати ліхтарик",
        "Збереження дуже довгих нотаток про товари може зайняти трохи часу на старіших пристроях",
        "Мініатюри зображень можуть виглядати піксельними на дисплеях високої роздільної здатності",
      ],
    },
    appUpdates: {
      title: "Оновлення застосунку",
      body: "Ми регулярно випускаємо оновлення з новими функціями, покращеннями та виправленнями помилок. Обов’язково оновлюйте WasOK через Google Play Store, щоб отримувати останні покращення.",
    },
    community: {
      title: "Спільнота",
      body: "Приєднуйтеся до спільноти користувачів, які приймають розумніші рішення про покупки з WasOK. Діліться порадами, ставте запитання та спілкуйтеся з іншими користувачами в наших соціальних каналах.",
    },
    emergency: {
      title: "Термінова підтримка",
      body: 'Якщо у вас виникла критична проблема, яка заважає використовувати застосунок, будь ласка, позначте свій лист як «ТЕРМІНОВО» в темі, і ми надамо пріоритет вашому запиту.',
    },
    cta: {
      heading: "Досі потрібна допомога?",
      body: "Наша служба підтримки завжди поруч. Не соромтеся звертатися з будь-якими запитаннями чи проблемами.",
      button: "Написати в підтримку",
    },
  },
  advertising: {
    pageTitle: "Реклама та монетизація",
    seoTitle: "Реклама — WasOK",
    seoDescription: "Як WasOK підходить до реклами та монетизації.",
    approach: {
      title: "Наш підхід",
      body: "У WasOK ми вважаємо, що ваші звички покупок і думки про товари є приватними та особистими. Наша бізнес-модель відображає цю базову цінність.",
    },
    noAds: {
      title: "Без реклами",
      body: "WasOK не показує жодної реклами. Ми ніколи не показуватимемо вам рекламу на основі товарів, які ви скануєте, оцінок, які ви ставите, або будь-яких інших даних, створених вами в застосунку. Ваш досвід використання WasOK повністю вільний від реклами.",
    },
    noDataSelling: {
      title: "Без продажу даних",
      body: "Ми не продаємо, не здаємо в оренду і не передаємо ваші дані рекламодавцям, брокерам даних чи будь-яким третім особам. Оскільки всі ваші дані зберігаються локально на пристрої, ми навіть не маємо до них доступу. Ваші відгуки про товари, списки покупок і нотатки належать лише вам.",
    },
    noTracking: {
      title: "Без відстеження",
      body: "WasOK не використовує трекінгові пікселі, аналітичні сервіси чи будь-які інші технології, що відстежують вашу поведінку або передають інформацію третім особам. Ми не відстежуємо, які товари ви скануєте, у яких магазинах робите покупки чи як використовуєте застосунок.",
    },
    sustainability: {
      title: "Як ми залишаємося стійкими",
      body: "Вам може бути цікаво, як ми підтримуємо WasOK безкоштовним без реклами чи продажу даних. Наш підхід простий:",
      items: [
        {
          label: "Безкоштовно та відкрито:",
          text: "WasOK безкоштовний для всіх, без преміум-рівнів чи платних обмежень",
        },
        {
          label: "Економна робота:",
          text: "Ми тримаємо витрати низькими, створюючи ефективне програмне забезпечення, орієнтоване на конфіденційність",
        },
        {
          label: "Добровільні пожертви:",
          text: "Користувачі, які люблять WasOK, можуть підтримати нас добровільними пожертвами",
        },
        {
          label: "Відкритий код:",
          text: "Ми можемо пропонувати консультаційні послуги або розробку на замовлення для організацій",
        },
      ],
    },
    noAffiliate: {
      title: "Без партнерських посилань",
      body: "WasOK не використовує партнерські посилання і не отримує комісії від роздрібних продавців. Коли ви скануєте товар, ми не перенаправляємо вас нікуди для покупки. Застосунок призначений виключно для особистого обліку та прийняття рішень.",
    },
    noPromotions: {
      title: "Без просування товарів",
      body: "Ми не приймаємо оплату від брендів чи виробників за просування їхніх товарів. WasOK ніколи не пропонуватиме товари, не виділятиме певні бренди чи не впливатиме на ваші оцінки жодним чином. Ваші думки — лише ваші.",
    },
    partnerships: {
      title: "Партнерства з третіми особами",
      body: "WasOK не співпрацює з маркетинговими компаніями, агрегаторами даних чи рекламними мережами. Ми працюємо незалежно і ставимо вашу конфіденційність понад усе.",
    },
    future: {
      title: "Плани на майбутнє",
      body: "Ми прагнемо зберегти WasOK вільним від реклами та орієнтованим на конфіденційність. Якщо нам колись знадобиться впровадити стійку бізнес-модель у майбутньому, ми:",
      items: [
        "Заздалегідь оголосимо про будь-які зміни",
        "Ніколи не підемо на компроміс щодо конфіденційності чи безпеки даних",
        "Завжди пропонуватимемо спосіб використовувати застосунок без відстеження чи реклами",
        "Прислухатимемося до відгуків і занепокоєнь користувачів",
      ],
    },
    supporting: {
      title: "Підтримка WasOK",
      body: "Якщо вам подобається WasOK і ви хочете підтримати нашу місію щодо приватної пам’яті про покупки, ви можете:",
      items: [
        "Розповісти друзям і родині про застосунок",
        "Залишити позитивний відгук у Google Play Store",
        "Поділитися з нами своїми відгуками та пропозиціями",
        "Розглянути можливість добровільної пожертви (коли буде доступно)",
      ],
    },
    cta: {
      heading: "Питання щодо наших політик?",
      body: "Ми прозорі щодо того, як працює WasOK. Якщо у вас є запитання про наш підхід до конфіденційності, монетизації чи сталості, будь ласка, зв’яжіться з нами.",
      button: "Зв’язатися з нами",
    },
  },
};
